import { render } from "./Referenzen.vue?vue&type=template&id=09ee9ff9&scoped=true"
import script from "./Referenzen.vue?vue&type=script&lang=js"
export * from "./Referenzen.vue?vue&type=script&lang=js"

import "./Referenzen.vue?vue&type=style&index=0&id=09ee9ff9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ee9ff9"]])

export default __exports__